<!-- Page Banner -->
<div class="page-banner-area item-bg2">
    <div class="container">
        <div class="page-banner-content">
            <h2>Technology Expertise</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Technology Expertise</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Portfolio -->
<section class="portfolio-area pt-100 pb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/java.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">JAVA</a></h3>
                        <span>Programming Language</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/.net.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">.Net MVC</a></h3>
                        <span>Programming Language</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/angular.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Angular</a></h3>
                        <span>Frontend Development</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/MSSQL.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Microsoft SQL Server</a></h3>
                        <span>DB Development</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/portfolio/portfolio-3.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Android</a></h3>
                        <span>Mobile Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/portfolio/portfolio-3.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">IOS</a></h3>
                        <span>Mobile Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/sharepoint.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">SharePoint</a></h3>
                        <span>Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/salesforce.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Sales Force</a></h3>
                        <span>Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/Selenium.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Selenium</a></h3>
                        <span>Testing Tool</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/jmeter.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">JMeter</a></h3>
                        <span>Testing Tool</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/nodejs.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">NodeJS</a></h3>
                        <span>Development Language</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/mongodb.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">MongoDB</a></h3>
                        <span>DB Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/Azure.png" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">Azure</a></h3>
                        <span>Cloud Development</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="single-portfolio-item">
                    <div class="portfolio-image">
                        <a routerLink="/technology-expertise">
                            <img src="assets/img/expertise/aws.jpg" alt="image">
                        </a>
                    </div>

                    <div class="portfolio-content">
                        <h3><a routerLink="/technology-expertise">AWS</a></h3>
                        <span>Cloud Development</span>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="default-shape">
        <div class="shape1"><img src="assets/img/default-shape/default-shape1.png" alt="image"></div>
        <div class="shape2"><img src="assets/img/default-shape/default-shape2.png" alt="image"></div>
        <div class="shape3"><img src="assets/img/default-shape/default-shape3.png" alt="image"></div>
        <div class="shape4"><img src="assets/img/default-shape/default-shape4.png" alt="image"></div>
    </div>
</section>
<!-- End Portfolio -->